import Image from 'next/image';

import GooglePlay from '@public/images/badges/download-app-google-play.png';
// Images
import DownloadAppStore from '@public/images/badges/download-app-store.png';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Lib
import { url_app_android, url_app_ios } from '@/lib/app/urlDownloadApp';

import H3 from '@/components/base/Headings/H3';
// Components
import ModalBlockContent from '@/components/base/Modal/ModalBlockContent';

const MobileViewAccessModal = () => {
    const { t } = useTranslation('scheduler');
    return (
        <div className="md:hidden">
            <ModalBlockContent size="xl" alignContent="items-start">
                <ModalBlockContent.Body className="py-12">
                    <ModalBlockContent.Title className="px-5 text-center sm:px-20">
                        {t('modal_mobile_view_access.title')}
                    </ModalBlockContent.Title>
                    <ModalBlockContent.Content className="p-m">
                        <p className="px-5 text-center font-GMedium text-icoGray-500 dark:text-icoDarkMode-wolf sm:px-20">
                            {t('modal_mobile_view_access.sub_title')}
                        </p>
                        <div className="mt-8 rounded-md bg-icoGray-100 px-12 py-8 dark:bg-icoDarkMode-deepBlack">
                            <H3>{t('modal_mobile_view_access.content_title')}</H3>
                            <p className="mt-2">
                                {t('modal_mobile_view_access.content_sub_title')}
                            </p>
                            <div className="mt-m flex flex-wrap">
                                <a
                                    href={url_app_ios}
                                    className="relative mr-2.5 flex rounded focus:outline-none focus:ring-2 focus:ring-icoBlue-200 focus:ring-offset-2 dark:ring-offset-icoDarkMode-deepBlack/80"
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    <Image
                                        src={DownloadAppStore}
                                        alt=""
                                        width={120}
                                        height={40}
                                        className="align-top"
                                    />
                                </a>
                                <a
                                    href={url_app_android}
                                    className="relative flex rounded focus:outline-none focus:ring-2 focus:ring-icoBlue-200 focus:ring-offset-2 dark:ring-offset-icoDarkMode-deepBlack/80"
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    <Image
                                        src={GooglePlay}
                                        alt=""
                                        width={134}
                                        height={40}
                                        className="align-top"
                                    />
                                </a>
                            </div>
                        </div>
                    </ModalBlockContent.Content>
                </ModalBlockContent.Body>
            </ModalBlockContent>
        </div>
    );
};

export default MobileViewAccessModal;
